export default "/images/uber-eats.png?440ca76089610a5b23d7a9b2f6e6a9a7";